// src/styles/theme.js
export const colors = {
  primary: '#9C3BC4',
  primaryDark: '#7B2E9C',
  primaryLight: '#FAEFFD',
  secondary: '#5B3FE0',
  brandPink: '#EC1E9C',
  brandGradient: 'linear-gradient(90deg, #EC1E9C 0%, #9C3BC4 55%, #5B3FE0 100%)',
  accent: '#06B6D4',
  accentLight: '#ECFEFF',
  bgPage: '#F8F9FB',
  bgCard: '#FFFFFF',
  bgSidebar: '#FFFFFF',
  bgHover: '#F3F4F6',
  bgSelected: '#FAEFFD',
  border: '#E5E7EB',
  borderLight: '#F3F4F6',
  borderFocus: '#9C3BC4',
  textPrimary: '#111827',
  textSecondary: '#6B7280',
  textMuted: '#9CA3AF',
  textOnPrimary: '#FFFFFF',
  success: '#10B981',
  successLight: '#ECFDF5',
  successText: '#065F46',
  warning: '#F59E0B',
  warningLight: '#FFFBEB',
  warningText: '#92400E',
  danger: '#EF4444',
  dangerLight: '#FEF2F2',
  dangerText: '#991B1B',
  info: '#3B82F6',
  infoLight: '#EFF6FF',
  infoText: '#1E40AF',
  sidebarActiveBg: '#FAEFFD',
  sidebarActiveText: '#9C3BC4',
  sidebarText: '#6B7280',
  sidebarTextHover: '#111827',
};

export const font = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const radius = {
  sm: '6px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  full: '9999px',
};

export const shadow = {
  sm: 'none',
  md: '0 1px 2px rgba(0,0,0,0.04)',
  lg: '0 2px 6px rgba(0,0,0,0.06)',
};

export const s = {
  card: {
    background: colors.bgCard,
    borderRadius: radius.lg,
    padding: '20px 24px',
    border: `1px solid ${colors.border}`,
    boxShadow: shadow.sm,
    marginBottom: '16px',
  },
  cardSm: {
    background: colors.bgCard,
    borderRadius: radius.lg,
    padding: '16px 20px',
    border: `1px solid ${colors.border}`,
    boxShadow: shadow.sm,
  },
  cardFlat: {
    background: colors.bgPage,
    borderRadius: radius.md,
    padding: '16px 20px',
    border: `1px solid ${colors.borderLight}`,
  },
  btn: {
    padding: '8px 16px',
    borderRadius: radius.md,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '13px',
    fontWeight: '500',
    letterSpacing: '-0.01em',
    border: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  btnPrimary: {
    padding: '9px 18px',
    borderRadius: radius.md,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '13px',
    fontWeight: '600',
    letterSpacing: '-0.01em',
    border: 'none',
    background: colors.brandGradient,
    color: colors.textOnPrimary,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  btnSecondary: {
    padding: '8px 16px',
    borderRadius: radius.md,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '13px',
    fontWeight: '500',
    letterSpacing: '-0.01em',
    border: `1px solid ${colors.border}`,
    background: colors.bgCard,
    color: colors.textPrimary,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  btnGhost: {
    padding: '6px 12px',
    borderRadius: radius.md,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '13px',
    fontWeight: '500',
    letterSpacing: '-0.01em',
    border: 'none',
    background: 'transparent',
    color: colors.textSecondary,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  btnDanger: {
    padding: '8px 16px',
    borderRadius: radius.md,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '13px',
    fontWeight: '500',
    letterSpacing: '-0.01em',
    border: 'none',
    background: colors.danger,
    color: '#fff',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  input: {
    padding: '8px 12px',
    borderRadius: radius.md,
    border: `1px solid ${colors.border}`,
    fontSize: '13px',
    color: colors.textPrimary,
    background: colors.bgCard,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  inputSm: {
    padding: '6px 10px',
    borderRadius: radius.sm,
    border: `1px solid ${colors.border}`,
    fontSize: '12px',
    color: colors.textPrimary,
    background: colors.bgCard,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  select: {
    padding: '8px 12px',
    borderRadius: radius.md,
    border: `1px solid ${colors.border}`,
    fontSize: '13px',
    color: colors.textPrimary,
    background: colors.bgCard,
    outline: 'none',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
  },
  label: {
    fontSize: '12px',
    fontWeight: '500',
    color: colors.textSecondary,
    marginBottom: '4px',
    display: 'block',
  },
  labelNormal: {
    fontSize: '13px',
    fontWeight: '500',
    color: colors.textPrimary,
    marginBottom: '6px',
    display: 'block',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 8px',
    borderRadius: radius.full,
    fontSize: '11px',
    fontWeight: '500',
  },
  badgeSuccess: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: radius.full,
    fontSize: '11px',
    fontWeight: '500',
    background: colors.successLight,
    color: colors.successText,
  },
  badgeWarning: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: radius.full,
    fontSize: '11px',
    fontWeight: '500',
    background: colors.warningLight,
    color: colors.warningText,
  },
  badgeDanger: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: radius.full,
    fontSize: '11px',
    fontWeight: '500',
    background: colors.dangerLight,
    color: colors.dangerText,
  },
  badgeInfo: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: radius.full,
    fontSize: '11px',
    fontWeight: '500',
    background: colors.infoLight,
    color: colors.infoText,
  },
  badgePrimary: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: radius.full,
    fontSize: '11px',
    fontWeight: '500',
    background: colors.primaryLight,
    color: colors.primary,
  },
  badgeGray: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: radius.full,
    fontSize: '11px',
    fontWeight: '500',
    background: '#F3F4F6',
    color: '#6B7280',
  },
  pageTitle: {
    fontSize: '22px',
    fontWeight: '600',
    color: colors.textPrimary,
    letterSpacing: '-0.02em',
    margin: 0,
  },
  pageSubtitle: {
    fontSize: '13px',
    color: colors.textSecondary,
    margin: '2px 0 0',
  },
  sectionTitle: {
    fontSize: '15px',
    fontWeight: '600',
    color: colors.textPrimary,
    letterSpacing: '-0.015em',
    margin: '0 0 4px',
  },
  sectionSubtitle: {
    fontSize: '12px',
    color: colors.textSecondary,
    margin: 0,
  },
  metricValue: {
    fontSize: '26px',
    fontWeight: '700',
    color: colors.textPrimary,
    letterSpacing: '-0.025em',
    fontVariantNumeric: 'tabular-nums',
    margin: '6px 0 2px',
    lineHeight: 1.2,
  },
  metricLabel: {
    fontSize: '12px',
    color: colors.textSecondary,
    margin: 0,
  },
  flexRow: {
    display: 'flex',
    alignItems: 'center',
  },
  flexBetween: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  divider: {
    borderTop: `1px solid ${colors.border}`,
    margin: '16px 0',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
  },
  th: {
    padding: '10px 16px',
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '600',
    color: colors.textSecondary,
    borderBottom: `1px solid ${colors.border}`,
    background: colors.bgPage,
  },
  td: {
    padding: '12px 16px',
    borderBottom: `1px solid ${colors.borderLight}`,
    color: colors.textPrimary,
    fontSize: '13px',
  },
  alertInfo: {
    background: colors.infoLight,
    border: `1px solid #BFDBFE`,
    borderRadius: radius.md,
    padding: '12px 16px',
    fontSize: '13px',
    color: colors.infoText,
  },
  alertSuccess: {
    background: colors.successLight,
    border: `1px solid #A7F3D0`,
    borderRadius: radius.md,
    padding: '12px 16px',
    fontSize: '13px',
    color: colors.successText,
  },
  alertWarning: {
    background: colors.warningLight,
    border: `1px solid #FDE68A`,
    borderRadius: radius.md,
    padding: '12px 16px',
    fontSize: '13px',
    color: colors.warningText,
  },
  alertDanger: {
    background: colors.dangerLight,
    border: `1px solid #FECACA`,
    borderRadius: radius.md,
    padding: '12px 16px',
    fontSize: '13px',
    color: colors.dangerText,
  },
};


export const chartPalette = ['#9C3BC4', '#5B3FE0', '#EC1E9C', '#B45FD3', '#7B6AE8', '#F05DB6', '#C9A7DC'];

export const tone = (i) => chartPalette[((i % chartPalette.length) + chartPalette.length) % chartPalette.length];

export const chartBase = {
  color: chartPalette,
  textStyle: { fontFamily: font, color: colors.textSecondary },
  grid: { left: 8, right: 14, top: 18, bottom: 6, containLabel: true },
  tooltip: {
    trigger: 'axis',
    backgroundColor: colors.bgCard,
    borderColor: colors.border,
    borderWidth: 1,
    padding: [8, 12],
    extraCssText: 'box-shadow:0 4px 14px rgba(17,24,39,0.08);border-radius:8px;',
    textStyle: { color: colors.textPrimary, fontSize: 12, fontFamily: font },
    axisPointer: { type: 'line', lineStyle: { color: colors.border, type: 'dashed' } },
  },
  xAxisStyle: {
    axisLine: { lineStyle: { color: colors.border } },
    axisTick: { show: false },
    axisLabel: { color: colors.textMuted, fontSize: 11 },
    splitLine: { show: false },
  },
  yAxisStyle: {
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { color: colors.textMuted, fontSize: 11 },
    splitLine: { lineStyle: { color: colors.borderLight } },
  },
};

export const lineGradient = {
  type: 'linear', x: 0, y: 0, x2: 1, y2: 0,
  colorStops: [
    { offset: 0, color: '#EC1E9C' },
    { offset: 0.55, color: '#9C3BC4' },
    { offset: 1, color: '#5B3FE0' },
  ],
};

export const areaGradient = {
  type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
  colorStops: [
    { offset: 0, color: 'rgba(156,59,196,0.16)' },
    { offset: 1, color: 'rgba(91,63,224,0.01)' },
  ],
};

export const ui = {
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    padding: '3px 9px',
    borderRadius: radius.sm,
    fontSize: '12px',
    fontWeight: '500',
    fontFamily: font,
    lineHeight: 1.5,
    background: colors.bgPage,
    border: `1px solid ${colors.border}`,
    color: colors.textSecondary,
    whiteSpace: 'nowrap',
  },
  chipStrong: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    padding: '3px 9px',
    borderRadius: radius.sm,
    fontSize: '12px',
    fontWeight: '500',
    fontFamily: font,
    lineHeight: 1.5,
    background: colors.primaryLight,
    border: '1px solid #EBD5F5',
    color: colors.primaryDark,
    whiteSpace: 'nowrap',
  },
  status: (active) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '12px',
    fontFamily: font,
    fontWeight: '500',
    color: active ? colors.textPrimary : colors.textMuted,
  }),
  statusDot: (active) => ({
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    flexShrink: 0,
    background: active ? colors.success : colors.textMuted,
    display: 'inline-block',
  }),
  num: {
    fontFamily: font,
    fontSize: '13px',
    fontWeight: '600',
    color: colors.textPrimary,
    fontVariantNumeric: 'tabular-nums',
  },
  numMuted: {
    fontFamily: font,
    fontSize: '13px',
    fontWeight: '400',
    color: colors.textSecondary,
    fontVariantNumeric: 'tabular-nums',
  },
  meter: {
    height: '6px',
    width: '100%',
    borderRadius: radius.full,
    background: colors.borderLight,
    overflow: 'hidden',
  },
  meterFill: (pct) => ({
    height: '100%',
    width: Math.max(0, Math.min(100, Number(pct) || 0)) + '%',
    borderRadius: radius.full,
    background: colors.brandGradient,
    transition: 'width .4s ease',
  }),
  segmented: {
    display: 'inline-flex',
    padding: '3px',
    gap: '2px',
    background: colors.bgPage,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.md,
  },
  segmentedBtn: (active) => ({
    padding: '5px 13px',
    borderRadius: radius.sm,
    border: 'none',
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '12px',
    fontWeight: active ? '600' : '500',
    letterSpacing: '-0.01em',
    background: active ? colors.bgCard : 'transparent',
    color: active ? colors.textPrimary : colors.textSecondary,
    boxShadow: active ? '0 1px 2px rgba(17,24,39,0.06)' : 'none',
  }),
  tab: (active) => ({
    padding: '10px 2px',
    marginRight: '22px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '13px',
    fontWeight: active ? '600' : '500',
    letterSpacing: '-0.01em',
    color: active ? colors.textPrimary : colors.textSecondary,
    borderBottom: active ? `2px solid ${colors.primary}` : '2px solid transparent',
    borderRadius: 0,
  }),
  tabBar: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.border}`,
    marginBottom: '20px',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    scrollbarWidth: 'none',
  },
  btnSm: {
    padding: '5px 11px',
    borderRadius: radius.sm,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '-0.01em',
    border: `1px solid ${colors.border}`,
    background: colors.bgCard,
    color: colors.textPrimary,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  btnPrimarySm: {
    padding: '6px 13px',
    borderRadius: radius.sm,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '-0.01em',
    border: 'none',
    background: colors.brandGradient,
    color: colors.textOnPrimary,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  btnQuiet: {
    padding: '5px 11px',
    borderRadius: radius.sm,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '-0.01em',
    border: '1px solid transparent',
    background: 'transparent',
    color: colors.textSecondary,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  btnDangerQuiet: {
    padding: '5px 11px',
    borderRadius: radius.sm,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '-0.01em',
    border: `1px solid ${colors.border}`,
    background: colors.bgCard,
    color: colors.dangerText,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  statBox: {
    background: colors.bgCard,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.lg,
    padding: '16px 18px',
  },
  statLabel: {
    fontSize: '12px',
    fontFamily: font,
    color: colors.textSecondary,
    margin: 0,
  },
  statValue: {
    fontSize: '24px',
    fontFamily: font,
    fontWeight: '600',
    color: colors.textPrimary,
    letterSpacing: '-0.025em',
    fontVariantNumeric: 'tabular-nums',
    margin: '6px 0 0',
    lineHeight: 1.2,
  },
  notice: {
    background: colors.bgPage,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.md,
    padding: '11px 14px',
    fontFamily: font,
    fontSize: '13px',
    color: colors.textSecondary,
  },
  emptyText: {
    fontFamily: font,
    fontSize: '13px',
    color: colors.textMuted,
    margin: 0,
  },
};

export default s;